import '../assets/Back.css';
import { defineComponent, useCssVars, computed, ref, watch, openBlock, createElementBlock, createElementVNode, createCommentVNode } from 'vue';
import { o as useStore } from './useStore.B0k3KXLh.js';

const _hoisted_1 = { class: "thn--tool-back" };
const _hoisted_2 = ["image-loaded"];
const _hoisted_3 = ["alt", "src"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Back",
  setup(__props) {
    useCssVars((_ctx) => ({
      "3a295ff2": flipBackground.value
    }));
    const store = useStore();
    const flipBackground = computed(() => store?.rtl ? "scaleX(-1)" : "none");
    const imageLoaded = ref(false);
    const imageUrl = computed(() => store?.styles.backgroundImage);
    const imageAlt = computed(() => store?.styles.backgroundImageAlt);
    function onLoadBackPhoto() {
      imageLoaded.value = true;
    }
    watch(() => store?.styles.backgroundImage, (oldVal, newVal) => {
      if (newVal !== oldVal) {
        imageLoaded.value = false;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = createElementVNode("div", { class: "thn--tool-back__color" }, null, -1)),
        !!imageUrl.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          "image-loaded": imageLoaded.value,
          class: "thn--tool-back__image"
        }, [
          createElementVNode("img", {
            onLoad: onLoadBackPhoto,
            alt: imageAlt.value,
            src: imageUrl.value
          }, null, 40, _hoisted_3)
        ], 8, _hoisted_2)) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Back.vue_vue_type_style_index_0_lang.CN582q2P.js.map
